// extracted by mini-css-extract-plugin
module.exports = {"title":"HomepageTypography_title__mre2i","intro":"HomepageTypography_intro__NGAUe"};